import styled from 'styled-components';
import StarsList from 'components/StarsList';
import Link from 'components/Link';
import { colorBlack500, colorGrey300, fontFamilyRaleway, fontFamilyRoboto, mediaQueryMobileLargeMin } from 'styleUtils';
export var CompanyInfo = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-jic0yg-0"
})(["display:flex;flex-direction:row;align-items:flex-start;width:100%;margin:0 0 24px 0;"]);
export var CompanyLogoWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-jic0yg-1"
})(["flex:none;width:32px;height:32px;text-align:center;"]);
export var CompanyLogo = /*#__PURE__*/styled.img.withConfig({
  componentId: "sc-jic0yg-2"
})(["width:100%;height:auto;max-height:100%;"]);
export var CompanyData = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-jic0yg-3"
})(["display:flex;flex-direction:column;margin:0 0 0 16px;"]);
export var CompanyDataTitleBlock = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-jic0yg-4"
})([""]);
export var CompanyDataTitle = /*#__PURE__*/styled(Link).withConfig({
  componentId: "sc-jic0yg-5"
})(["cursor:pointer;color:", ";font-family:", ";font-weight:bold;font-size:14px;line-height:14px;&:hover,&:active,&:focus{color:", ";}"], colorBlack500, fontFamilyRaleway, colorBlack500);
export var CompanyDataMore = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-jic0yg-6"
})(["display:flex;flex-direction:row;align-items:center;margin:6px 0 0 0;"]);
export var LicenseSpan = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-jic0yg-7"
})(["font-family:", ";font-size:13px;line-height:13px;color:", ";"], fontFamilyRoboto, colorGrey300);
export var RatingValue = /*#__PURE__*/styled(StarsList).withConfig({
  componentId: "sc-jic0yg-8"
})(["margin:0 8.25px 0 0;*{padding-right:0;}@media ", "{margin-left:0;}"], mediaQueryMobileLargeMin);